// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');

class DaysLeft extends React.Component {
    render() {
        const { daysLeft, onHandleGoToPanel, onHandleToggleCalendar, isLoadingTargetDate, isLoadingContinue, disabled } = this.props;

        return (
            <div className="row">
                <div className="col-sm-12">
                    <p className="mortgage-request-manager-view__text">
                        {formatText('mortgageRequestManager-daysLeftText1', [daysLeft])}
                    </p>

                    <p className="mortgage-request-manager-view__text">
                        {formatText('mortgageRequestManager-daysLeftText2')}
                    </p>
                </div>
                <div className="col-sm-3 mortgage-request-target-date__space-button">
                    <OKButton
                        block
                        modifier="ghost"
                        onClick={event => onHandleToggleCalendar(event, true)}
                        loading={isLoadingTargetDate}
                        disabled={disabled}
                    >
                        {formatText('mortgageRequestManager-daysLeftYesButton')}
                    </OKButton>
                </div>
                <div className="col-sm-4 mortgage-request-target-date__space-button">
                    <OKButton block={true} modifier="secondary" onClick={onHandleGoToPanel} loading={isLoadingContinue} disabled={disabled}>
                        {formatText('mortgageRequestManager-daysLeftContinueButtonNew')}
                    </OKButton>
                </div>
            </div>
        );
    }
}

DaysLeft.propTypes = {
    daysLeft: PropTypes.number,
    onHandleGoToPanel: PropTypes.func,
    onHandleToggleCalendar: PropTypes.func,
    isLoadingContinue: PropTypes.bool,
    isLoadingTargetDate: PropTypes.bool,
    disabled: PropTypes.bool
};

module.exports = DaysLeft;
